/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';

export const PROGRESS_BAR_TYPE_MAP = {
    INFO: 'INFO',
    SUCCESS: 'SUCCESS',
    WARNING: 'WARNING',
    ERROR: 'ERROR',
};

const ProgressBar = ({ type, borderRadius, percentage }) => (
    <Styled.ProgressBarContainer data-test-id="progress-bar-container" type={type} borderRadius={borderRadius}>
        <Styled.ProgressBarFiller data-test-id="progress-bar-filler" type={type} percentage={percentage < 0 ? 0 : (percentage > 100 ? 100 : percentage)} />
    </Styled.ProgressBarContainer>
);

ProgressBar.propTypes = {
    type: PropTypes.oneOf(Object.values(PROGRESS_BAR_TYPE_MAP)),
    borderRadius: PropTypes.string,
    percentage: PropTypes.number,
};

ProgressBar.defaultProps = {
    type: PROGRESS_BAR_TYPE_MAP.INFO,
    borderRadius: '0',
    percentage: 0,
};

export default ProgressBar;
